import { call } from './client'
import type { Item, ItemInput, Photo } from '../types'

export const items = (): Promise<Item[]> => call('/items')

export const item = (id: number): Promise<Item> => call(`/items/${id}`)

export const createItem = (body: ItemInput): Promise<Item> =>
  call('/items', { method: 'POST', body })

export function uploadPhoto(id: number, file: File): Promise<Photo> {
  const form = new FormData()
  form.append('file', file)
  return call(`/items/${id}/photos`, { method: 'POST', form })
}
